import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  loadInnovatorHighlightsRequest: ['payload'],
  setInnovatorHighlights: ['payload'],
}, { prefix: '[INNOVATOR HIGHLIGHTS] ' });
